import { render, staticRenderFns } from "./OptionGroup.vue?vue&type=template&id=fb6a6616&scoped=true&"
import script from "./OptionGroup.vue?vue&type=script&lang=js&"
export * from "./OptionGroup.vue?vue&type=script&lang=js&"
import style0 from "./OptionGroup.vue?vue&type=style&index=0&id=fb6a6616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a6616",
  null
  
)

export default component.exports